import React from "react";
import "../../containers/ConfirmOpenTicket.css";
import { translations } from "../../containers/assets/translations";
import { Button } from "react-bootstrap";

export default class VoucherConfirm extends React.Component {
  render() {
    return (
      <div ref={this.props.jumpToTop}>
        {this.props.displayVouchers ? (
          <div>
            {this.props.hasPersonVouchers ? (
              <div className="col-md-12 head">
                <div className="col-md-3">
                  {translations[this.props.lang]["Ticket Number"]}
                </div>

                <div className="col-md-4">
                  {translations[this.props.lang]["Surname Name"]}
                </div>

                <div className="col-md-3">Download Pdf</div>
              </div>
            ) : null}
            {this.props.vouchers.map((voucher, index) => {
              if (!voucher.hasOwnProperty("RegistrationNumber")) {
                return (
                  <div
                    className="col-md-12 col-xs-12 resultsRTicks"
                    key={voucher.BookID}
                  >
                    <div className="col-md-3 col-xs-3 resultVouch">
                      {voucher.TicketNumber}
                    </div>

                    <div className="col-md-4 col-xs-4 resultVouch">
                      {voucher.Surname} {voucher.Name}
                    </div>

                    <div className="col-md-3 col-xs-4 resultVouchbtn">
                      <a
                        href={this.props.confirmationPDFArray[index]}
                        target="_blank"
                      >
                        Download {"\t\t\t\t"}
                        <span className="glyphicon glyphicon-download-alt" />
                      </a>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={voucher.BookID}>
                    <div className="col-md-12 head HeaderVoucherVeh">
                      <div className="col-md-2">
                        {translations[this.props.lang]["Ticket Number"]}
                      </div>

                      <div className="col-md-4">
                        {translations[this.props.lang]["Driver Name"]}
                      </div>
                      <div className="col-md-2">
                        {translations[this.props.lang]["Plates"]}
                      </div>
                      <div className="col-md-4">Download Pdf</div>
                    </div>
                    <div
                      className="col-md-12 col-xs-12 resultsRTicks"
                      key={voucher.BookID}
                    >
                      <div className="col-md-2 col-xs-3 resultVouch">
                        {voucher.TicketNumber}
                      </div>

                      <div className="col-md-3 col-xs-4 resultVouch">
                        {voucher.DriverName}
                      </div>
                      <div className="col-md-2 col-xs-1 resultVouch">
                        {voucher.RegistrationNumber}
                      </div>
                      <div className="col-md-3 col-xs-4 resultVouchbtn">
                        <a
                          href={this.props.confirmationPDFArray[index]}
                          target="_blank"
                        >
                          Download {"\t\t\t\t"}
                          <span className="glyphicon glyphicon-download-alt" />
                        </a>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
            <Button
              className="btn btn-primary checkin btn btn-lg "
              bsSize="large"
              type="button"
              onClick={() => this.props.goBackToFirstScreen()}
            >
              {translations[this.props.lang]["Go Back"]}
              {"\t\t\t\t"}
              <span className="glyphicon glyphicon-circle-arrow-left" />
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmOpenTicketComponents/VoucherConfirm.js